import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomerOrderOfferBacklogReportPage } from "src/components/views/erp/sales/reports/CustomerOrderOfferBacklogReportPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/sales/reports/customerOrderOfferBacklog")({
	staticData: {
		title: i18n.t("customer_order_offer_backlog_report"),
		legacyViewKey: "customerOrderOfferBacklogReportPage",
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <CustomerOrderOfferBacklogReportPage />;
}
